// extracted by mini-css-extract-plugin
module.exports = {"label":"color-palette_label__2d4iX","description":"color-palette_description__17YWI","colorPaletteWrapper":"color-palette_colorPaletteWrapper__QF4SZ"};